import { FC, SVGProps } from "react";

const PointsExchangeIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      stroke="currentcolor"
      {...props}
    >
      <path d="M10.6667 2.5L13.3334 5.83333L10.6667 9.16667" />
      <path d="M13.3334 5.83203H2.66675" />
      <path d="M5.33341 17.4987L2.66675 14.1654L5.33341 10.832" />
      <path d="M2.66675 14.168H13.3334" />
    </svg>
  );
};

export default PointsExchangeIcon;
